import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectShowPopupBlockModal, setShowPopupBlockModal } from '../redux/slicers/appSlicer';
import { useInfoDialogaActions } from './useInfoDialogaActions';
import { windowOpenV2 } from '../helpers/jsHelper';

export const usePopupBlockerModal = () => {
  const dispatch = useDispatch();
  const show = useSelector(selectShowPopupBlockModal);
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const commonDialogProps = {
    cancelButtonText: 'Cancel',
    cancelBtnColor: 'light',
    okBtnColor: 'warning',
  };

  useEffect(() => {
    if (!show) return;
    openInfoDialog({
      ...commonDialogProps,
      title: 'Popup Blocked',
      description: "Allow them in your browser settings or press 'Continue' to proceed.",
      buttonText: 'Continue',
      onButtonClick: () => {
        const link = window.popupBlockerModalLink;
        const target = window.popupBlockerModalTarget;
        if (link && target) windowOpenV2(link, target);
        closeInfoDialog();
        dispatch(setShowPopupBlockModal(false));
        window.popupBlockerModalLink = null;
        window.popupBlockerModalTarget = null;
      },
    });
  }, [show]);

  return;
};
